"use strict";

exports.__esModule = true;
exports.default = void 0;
var _arrayMap = _interopRequireDefault(require("./_arrayMap.js"));
var _copyArray = _interopRequireDefault(require("./_copyArray.js"));
var _isArray = _interopRequireDefault(require("./isArray.js"));
var _isSymbol = _interopRequireDefault(require("./isSymbol.js"));
var _stringToPath = _interopRequireDefault(require("./_stringToPath.js"));
var _toKey = _interopRequireDefault(require("./_toKey.js"));
var _toString = _interopRequireDefault(require("./toString.js"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * Converts `value` to a property path array.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Util
 * @param {*} value The value to convert.
 * @returns {Array} Returns the new property path array.
 * @example
 *
 * _.toPath('a.b.c');
 * // => ['a', 'b', 'c']
 *
 * _.toPath('a[0].b.c');
 * // => ['a', '0', 'b', 'c']
 */
function toPath(value) {
  if ((0, _isArray.default)(value)) {
    return (0, _arrayMap.default)(value, _toKey.default);
  }
  return (0, _isSymbol.default)(value) ? [value] : (0, _copyArray.default)((0, _stringToPath.default)((0, _toString.default)(value)));
}
var _default = exports.default = toPath;